/**
 * Renders a search component
 */
export const SearchComponent: ng.IComponentOptions = {
  controller: 'SearchController',
  controllerAs: 'vm',
  bindings: {
    onPerformSearch: '='
  },
  templateUrl: 'app/angularJS/components/search/search.html'
};